import type { CityImage } from '@/pages/articlesSights/entities/cityArticles/models';
import type { CityImage as EncodedCityImage } from '@/shared/api/experience';

/**
 * Преобразует данные из API во внутреннее представление изображения города.
 *
 * @param encoded данные из API
 * @returns внутреннее представление
 */
export const normalizeCityImage = (encoded?: EncodedCityImage): CityImage => {
  return {
    cover: encoded?.cover ?? '',
    thumbnail: encoded?.thumbnail ?? '',
  };
};
